import styled from 'styled-components';
import Box from '../../Box';

export const ImageBoxWrapper = styled(Box)`
  img {
    width: 100%;
    height: 100%;
    vertical-align: unset;
  }
`;
